<template>
  <div id="wholePage">
    <div class="modeBtns">
      <el-button type="primary" @click="saveProgram" class="previewModeBtn">保存</el-button>
      <el-button type="primary" @click="combileProgram" class="previewModeBtn">编译</el-button>
      <el-button type="primary" @click="pickDeviceVisible = true" class="previewModeBtn">发布</el-button>
    </div>

    <div id="create">
      <el-input v-if="programType===1"
          type="textarea"
          :rows="20"
          placeholder="请输入内容"
          v-model="sourceCode">
      </el-input>
      编译信息
      <el-input
          type="textarea"
          :rows="10"
          v-model="combile_description"
          readonly
      >
      </el-input>
    </div>

    <!--选择发布设备页面-->
    <el-dialog title="请选择发布的设备" width="30%" :visible.sync="pickDeviceVisible">
      <el-select v-model="deviceId" clearable placeholder="请选择">
        <el-option
            v-for="item in deviceList"
            :key="item.id"
            :label="item.deviceName"
            :value="item.id">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="pickDeviceVisible = false">取 消</el-button>
        <el-button type="primary" @click=publishProgram>确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="提示"
        :visible.sync="exitDialogVisiable"
        width="30%"
    >
      <span>是否确认离开此页面(若未保存将丢失修改记录)？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelExit">取 消</el-button>
        <el-button type="primary" @click="confirmExit">确 定</el-button>
     </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "../../../config/api";

export default {
  name: "EditProgram",    // 编辑程序
  props: {
    companyId: Number,
    programId: Number,
  },
  data() {
    return {
      program: {},     // 当前程序的所有内容
      programType: "",
      sourceCode:"",   // 当前程序内容
      combile_description: "",   // 编译信息
      deviceList:[],    // 设备信息
      deviceId: '',      // 选择的设备id
      exitDialogVisiable: false,
      pickDeviceVisible: false,
      //退出使用
      exitFunc: null,
      exitNode: null
    }
  },
  mounted() {
    this.getPLCById(this.programId);
    this.getDeviceList();
    this.userId = window.localStorage.getItem('userid');
  },
  methods: {

    // 获得设备列表
    getDeviceList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
      }
      this.$axiosRequest({
        url: API.getDeviceList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.deviceList = res.data['deviceList']
        }
      });
    },

    // 获得程序内容
    getPLCById(id) {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        companyId: this.companyId,
        id: id
      }
      this.$axiosRequest({
        url: API.getPLCById,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          this.program = res.data['plc']
          this.sourceCode = this.program["sourceCode"]
          this.programType = this.program["programType"]
        }
      });
    },

    // 保存程序
    saveProgram() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        id: this.program["id"],
        sourceCode: this.sourceCode,
        programType: this.programType,
        description : this.program["description"],
      }
      // console.log("保存的数据为:",data)
      this.$axiosRequest({
        url: API.updatePLC,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data === 0) {
            this.$message({
              message: '已存在该标题脚本！',
              type: 'error',
            })
          } else if (res.data === -2) {
            this.$message({
              message: '参数出错！',
              type: 'error',
            })
          } else if (res.data === -1) {
            //console.log("系统错误")
            this.$message({
              message: '系统错误！',
              type: 'error',
            })
          } else {
            this.$message({
              message: '保存成功！',
              type: 'success',
            })
          }
        }
      });
    },

    combileProgram() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        id: this.program["id"],
        userid: this.userid,
      }
      this.$axiosRequest({
        url: API.combilePLC,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          let combile_status = res.data["combile_status"]
          this.combile_description = res.data["combile_description"]
          if (combile_status === 1) {
            this.$message({
              message: '编译成功！',
              type: 'success',
            })
          } else if (combile_status === 2) {
            this.$message({
              message: '编译失败！',
              type: 'error',
            })
          }
        }
      });
    },

    // 发布程序
    publishProgram() {
      if (this.deviceId === '') {
        this.$message({
            message: "请选择绑定的设备",
            type: "error",
        })
        return
      }
      this.pickDeviceVisible = false;
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
        id: this.program["id"],
        device_id: this.deviceId,
        userid: this.userid,
      }
      this.$axiosRequest({
        url: API.publishPLC,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          let data = res.data;
          if (data > 0) {
            this.$message({
              message: '发布成功！',
              type: 'success',
            })
          } else if (data === -3) {
            this.$message({
              message: '程序未编译成功！',
              type: 'error',
            })
          } else if (data === -2) {
            this.$message({
              message: '参数不完整！',
              type: 'error',
            })
          } else if (data === -1) {
            this.$message({
              message: '执行出错！',
              type: 'error',
            })
          }
        }
      });
    },

    change(func, node) {
      this.exitDialogVisiable = true;
      this.exitFunc = func;
      this.exitNode= node;
    },
    //取消退出
    cancelExit(){
      this.exitDialogVisiable = false;
      this.$emit('testback');
    },
    confirmExit(){
      this.exitDialogVisiable = false;
      this.exitFunc(this.exitNode);
    },
  }
}
</script>

<style scoped>

</style>